module.exports = __webpack_public_path__ + "static/img/sfzrm.d53a3cf5.png";